export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/'
export const TIME_OUT = 30
export const PAGE_LENGTH = 10

export const API_KEY = '12ac93db-f100-4026-aeb0-a4cc7ca26cfc'

export const MODAL_CLOSE = 2.5